<div class="login">
  <div class="d-flex justify-content-center h-100">
    <div class="card">
      <div class="card-header">
        <h3>Login</h3>
        <div class="d-flex justify-content-end social_icon"></div>
      </div>
      <div class="card-body">
        <form [formGroup]="loginForm">
          <div class="input-group form-group">
            <div class="input-group-prepend">
              <span class="input-group-text"
                ><i class="material-icons"> account_circle </i></span
              >
            </div>
            <input
              [ngClass]="noUserFound ? 'inputError' : ''"
              formControlName="username"
              type="text"
              class="form-control heightLogin"
              placeholder="Usuario"
            />
          </div>
          <div class="input-group form-group">
            <div class="input-group-prepend">
              <span class="input-group-text"
                ><i class="material-icons"> lock </i></span
              >
            </div>
            <input
              [ngClass]="noUserFound ? 'inputError' : ''"
              formControlName="password"
              type="password"
              class="form-control heightLogin"
              placeholder="Contraseña"
            />
          </div>
          <div *ngIf="noUserFound" class="error">{{ noUserFound }}</div>
          <div class="form-group">
            <button
              (click)="loginApp(loginForm.value)"
              [disabled]="!loginForm.valid"
              class="btn float-right login_btn"
            >
              Entrar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
